import axios from 'axios';
import type { DateTime } from 'luxon';

export default class ProducersService
{
    public static async getList(filter: FilterModel, pager: Pager)
    {
        return (await axios.get<Pagination<Resource<ListItemModel>>>(`admin/store/producers`, {
            params: { ...filter, ...pager.data() }
        })).data;
    }

    public static async fetch(id: number)
    {
        return (await axios.get<Resource<FormModel>>(`admin/store/producers/${id}`)).data;
    }

    public static async create(model: FormModel)
    {
        return (await axios.post(`admin/store/producers`, model)).data as ResponseModel;
    }

    public static async update(id: number, model: FormModel)
    {
        return (await axios.put(`admin/store/producers/${id}`, model)).data as ResponseModel;
    }

    public static async remove(id: number)
    {
        return (await axios.delete(`admin/store/producers/${id}`)).data as Statement;
    }

    public static async active(id: number, model: ActiveModel)
    {
        return (await axios.put(`admin/store/producers/${id}/active`, model)).data as Statement;
    }

    public static async getAutocompleteList(search: string, limit: number = 10, excluded: number[] = [])
    {
        return (await axios.get<AutocompleteListModel[]>('admin/store/producers/autocomplete', {
            params: {
                search: search,
                limit: limit,
                excluded: excluded
            }
        })).data;
    }

    public static async fetchAutocompleteModel(id: number)
    {
        return (await axios.get<AutocompleteListModel[]>(`admin/store/producers/autocomplete/${id}`)).data;
    }

    public static async getListByIds(producersIds: number[])
    {
        return (await axios.get<AutocompleteListModel[]>(`admin/store/producers/ids`, {
            params: {
                producersIds
            }
        })).data;
    }
}

export interface ListItemModel
{
    id: number;
    name: string;
    dateModifiedUtc: DateTime;
    createdBy: string;
    isActive: boolean;
}

export interface FormModel
{
    id: number;
    name: string;
    summary: Record<string, string>;
    description: Record<string, string>;
    isActive: boolean;
    logo: FileResource;
    picture: FileResource;
    attachments: FileResource[];
}

export interface FilterModel
{
    name: string;
    dateModifiedFromUtc?: DateTime;
    dateModifiedDueUtc?: DateTime;
}

export interface ResponseModel
{
    id: number;
}

export interface ActiveModel
{
    isActive: boolean;
}

export interface AutocompleteListModel
{
    id: number;
    name: string;
}
